import { TemplateConfig } from '@/types';
import MinimalTemplate from './MinimalTemplate';
import BusinessTemplate from './BusinessTemplate';
import ModernTemplate from './ModernTemplate';
import FreshTemplate from './FreshTemplate';
import InternetTemplate from './InternetTemplate';
import AcademicTemplate from './AcademicTemplate';
import CreativeTemplate from './CreativeTemplate';
import TimelineTemplate from './TimelineTemplate';
import { collectionTemplateConfigs } from './collection';
import { realTemplateComponents } from './real';

export const templateRegistry: TemplateConfig[] = [
  {
    id: 'minimal-classic',
    name: '极简经典',
    slug: 'minimal-classic',
    description: '最基础、最通用的简历模板。去除一切多余装饰，以内容为核心。',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ['personal', 'intention', 'education', 'workExperience', 'projects', 'skills', 'summary'],
    isPremium: false,
    category: 'minimal',
    tags: ['极简', '商务', '通用'],
    thumbnail: '/templates/minimal-classic.png',
    themes: [
      { id: 'black', name: '经典黑', colors: { primary: '#1F2937', secondary: '#4B5563', accent: '#374151', background: '#FFFFFF', surface: '#F9FAFB', text: '#111827', textMuted: '#9CA3AF', border: '#E5E7EB' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'blue', name: '商务蓝', colors: { primary: '#2563EB', secondary: '#3B82F6', accent: '#1D4ED8', background: '#FFFFFF', surface: '#EFF6FF', text: '#1E3A8A', textMuted: '#6B7280', border: '#BFDBFE' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'teal', name: '稳重藏青', colors: { primary: '#0F766E', secondary: '#14B8A6', accent: '#115E59', background: '#FFFFFF', surface: '#F0FDFA', text: '#134E4A', textMuted: '#6B7280', border: '#99F6E4' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'business-blue',
    name: '商务蓝调',
    slug: 'business-blue',
    description: '传统商务简历，以蓝色为主调，稳重专业。',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ['personal', 'intention', 'education', 'workExperience', 'skills', 'summary'],
    isPremium: false,
    category: 'business',
    tags: ['商务', '应届生', '行政'],
    thumbnail: '/templates/business-blue.png',
    themes: [
      { id: 'blue', name: '商务蓝', colors: { primary: '#1E40AF', secondary: '#3B82F6', accent: '#EFF6FF', background: '#FFFFFF', surface: '#EFF6FF', text: '#1E3A8A', textMuted: '#6B7280', border: '#BFDBFE' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'red', name: '经典红', colors: { primary: '#991B1B', secondary: '#DC2626', accent: '#FEE2E2', background: '#FFFFFF', surface: '#FEF2F2', text: '#7F1D1D', textMuted: '#6B7280', border: '#FECACA' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'gray', name: '深灰', colors: { primary: '#374151', secondary: '#6B7280', accent: '#F3F4F6', background: '#FFFFFF', surface: '#F9FAFB', text: '#111827', textMuted: '#6B7280', border: '#E5E7EB' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'modern-split',
    name: '现代双栏',
    slug: 'modern-split',
    description: '左右分栏布局，左侧放个人信息和技能，右侧放工作、项目经历。',
    layout: 'two-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ['personal', 'skills', 'education', 'workExperience', 'projects', 'summary'],
    isPremium: false,
    category: 'modern',
    tags: ['现代', '技术', '产品经理'],
    thumbnail: '/templates/modern-split.png',
    themes: [
      { id: 'navy', name: '蓝灰分割', colors: { primary: '#1E3A5F', secondary: '#2563EB', accent: '#1E3A5F', background: '#FFFFFF', surface: '#F1F5F9', text: '#F8FAFC', textMuted: '#94A3B8', border: '#334155' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'green', name: '绿灰分割', colors: { primary: '#064E3B', secondary: '#059669', accent: '#064E3B', background: '#FFFFFF', surface: '#F0FDF4', text: '#F0FDF4', textMuted: '#6B7280', border: '#065F46' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'purple', name: '紫灰分割', colors: { primary: '#581C87', secondary: '#7C3AED', accent: '#581C87', background: '#FFFFFF', surface: '#FAF5FF', text: '#FAF5FF', textMuted: '#A78BFA', border: '#7C3AED' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'fresh-green',
    name: '清新绿',
    slug: 'fresh-green',
    description: '简洁明快的绿色调模板，给人清新脱俗的感觉。',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ['personal', 'education', 'workExperience', 'projects', 'skills'],
    isPremium: false,
    category: 'fresh',
    tags: ['清新', '创意', '教育'],
    thumbnail: '/templates/fresh-green.png',
    themes: [
      { id: 'green', name: '清新绿', colors: { primary: '#059669', secondary: '#10B981', accent: '#D1FAE5', background: '#FFFFFF', surface: '#F0FDF4', text: '#064E3B', textMuted: '#6B7280', border: '#A7F3D0' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'cyan', name: '天蓝', colors: { primary: '#0891B2', secondary: '#22D3EE', accent: '#CFFAFE', background: '#FFFFFF', surface: '#ECFEFF', text: '#164E63', textMuted: '#6B7280', border: '#67E8F9' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'orange', name: '橙红', colors: { primary: '#C2410C', secondary: '#F97316', accent: '#FFEDD5', background: '#FFFFFF', surface: '#FFF7ED', text: '#7C2D12', textMuted: '#6B7280', border: '#FDBA74' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'internet-style',
    name: '互联网风格',
    slug: 'internet-style',
    description: '偏向互联网行业的现代感模板，采用卡片式和时尚布局。',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ['personal', 'skills', 'workExperience', 'projects', 'education'],
    isPremium: false,
    category: 'internet',
    tags: ['互联网', '程序员', '现代'],
    thumbnail: '/templates/internet-style.png',
    themes: [
      { id: 'dark', name: '极客黑', colors: { primary: '#18181B', secondary: '#3F3F46', accent: '#F4F4F5', background: '#FFFFFF', surface: '#FAFAFA', text: '#18181B', textMuted: '#71717A', border: '#E4E4E7' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'purple', name: '极客紫', colors: { primary: '#581C87', secondary: '#7C3AED', accent: '#F3E8FF', background: '#FFFFFF', surface: '#FAF5FF', text: '#3B0764', textMuted: '#8B5CF6', border: '#DDD6FE' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'cyan', name: '极客青', colors: { primary: '#0C4A6E', secondary: '#0284C7', accent: '#E0F2FE', background: '#FFFFFF', surface: '#F0F9FF', text: '#082F49', textMuted: '#38BDF8', border: '#BAE6FD' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'academic',
    name: '学术风',
    slug: 'academic',
    description: '干净、正式的学术简历风格，适合考研、申博、留学申请。',
    layout: 'single-column',
    supportsPhoto: false,
    supportsMultiPage: true,
    defaultSections: ['personal', 'education', 'workExperience', 'projects', 'skills', 'summary'],
    isPremium: true,
    category: 'academic',
    tags: ['学术', '考研', '留学'],
    thumbnail: '/templates/academic.png',
    themes: [
      { id: 'red', name: '深红学院', colors: { primary: '#7F1D1D', secondary: '#991B1B', accent: '#FEF2F2', background: '#FFFFFF', surface: '#FEF2F2', text: '#450A0A', textMuted: '#78716C', border: '#E7E5E4' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'navy', name: '海军蓝', colors: { primary: '#1E3A5F', secondary: '#1E40AF', accent: '#EFF6FF', background: '#FFFFFF', surface: '#EFF6FF', text: '#172554', textMuted: '#64748B', border: '#CBD5E1' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'green', name: '墨绿', colors: { primary: '#064E3B', secondary: '#065F46', accent: '#ECFDF5', background: '#FFFFFF', surface: '#ECFDF5', text: '#022C22', textMuted: '#059669', border: '#A7F3D0' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'creative-designer',
    name: '创意设计师',
    slug: 'creative-designer',
    description: '大留白、强设计感的模板。空间感极强，适合设计、艺术、文创行业。',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ['personal', 'intention', 'workExperience', 'projects', 'education', 'skills'],
    isPremium: true,
    category: 'creative',
    tags: ['创意', '设计', '艺术'],
    thumbnail: '/templates/creative-designer.png',
    themes: [
      { id: 'bw', name: '极简黑白', colors: { primary: '#000000', secondary: '#333333', accent: '#F5F5F5', background: '#FFFFFF', surface: '#FAFAFA', text: '#1A1A1A', textMuted: '#999999', border: '#E5E5E5' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'mint', name: '薄荷绿', colors: { primary: '#2D5A4C', secondary: '#4A7C6F', accent: '#E8F5E9', background: '#FFFFFF', surface: '#F1F8E9', text: '#1B4332', textMuted: '#95D5B2', border: '#D8F3DC' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'pink', name: '烟粉红', colors: { primary: '#9B2335', secondary: '#BC243C', accent: '#FDEDEC', background: '#FFFFFF', surface: '#FDEDEC', text: '#641E16', textMuted: '#D98880', border: '#F5B7B1' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'timeline',
    name: '时间轴',
    slug: 'timeline',
    description: '采用时间轴形式展示经历，视觉冲击力强。适合工作年限较长的求职者。',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ['personal', 'intention', 'workExperience', 'skills', 'education', 'certificates'],
    isPremium: true,
    category: 'timeline',
    tags: ['时间线', '时间轴', '管理', '高级'],
    thumbnail: '/templates/timeline.png',
    themes: [
      { id: 'navy', name: '深蓝时间轴', colors: { primary: '#1E3A5F', secondary: '#3B82F6', accent: '#EFF6FF', background: '#FFFFFF', surface: '#EFF6FF', text: '#1E293B', textMuted: '#64748B', border: '#BFDBFE' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'purple', name: '紫金时间轴', colors: { primary: '#4C1D95', secondary: '#7C3AED', accent: '#EDE9FE', background: '#FFFFFF', surface: '#EDE9FE', text: '#2E1065', textMuted: '#8B5CF6', border: '#C4B5FD' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
      { id: 'cyan', name: '青蓝时间轴', colors: { primary: '#0C4A6E', secondary: '#0EA5E9', accent: '#E0F2FE', background: '#FFFFFF', surface: '#E0F2FE', text: '#082F49', textMuted: '#0284C7', border: '#7DD3FC' }, font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' } },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  ...collectionTemplateConfigs,
];

export const templateComponents: Record<string, React.FC<{ data: import('@/types').ResumeData; theme: import('@/types').TemplateTheme }>> = {
  'minimal-classic': MinimalTemplate,
  'business-blue': BusinessTemplate,
  'modern-split': ModernTemplate,
  'fresh-green': FreshTemplate,
  'internet-style': InternetTemplate,
  'academic': AcademicTemplate,
  'creative-designer': CreativeTemplate,
  'timeline': TimelineTemplate,
  ...realTemplateComponents,
};

export function getTemplateById(id: string): TemplateConfig | undefined {
  return templateRegistry.find((t) => t.id === id);
}
